// Theme: mist
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'mist',
  name: 'MIST',
  tagline: 'MIST',
  description: 'Nevoa matinal. Tons neutros, atmosfera eterea.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 250,
  swatches: ['#2A2F3C', '#BEC3D2', '#363C4C', '#F2F2F4'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
      '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 25%, transparent)'
    },
    shellClasses: 'font-sans theme-mist'
  },
  colorVars: {
    '--accent': '#7E879E',
    '--accent-foreground': '#2A2F3C',
    '--background': '#2A2F3C',
    '--border': '#7E879E',
    '--card': '#363C4C',
    '--card-border-active': 'rgba(190, 195, 210, 0.08)',
    '--card-completed': '#3C4354',
    '--card-foreground': '#F2F2F4',
    '--card-glow': 'rgba(190, 195, 210, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2F3C',
    '--foreground': '#F2F2F4',
    '--hold-fill': '#BEC3D2',
    '--input': '#363C4C',
    '--modal-bg': '#2A2F3C',
    '--modal-border': '#7E879E',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#363C4C',
    '--muted-foreground': '#BEC3D2',
    '--nav-active': '#BEC3D2',
    '--nav-bg': '#2A2F3C',
    '--popover': '#363C4C',
    '--popover-foreground': '#F2F2F4',
    '--primary': '#BEC3D2',
    '--primary-foreground': '#2A2F3C',
    '--ring': '#BEC3D2',
    '--secondary': '#7E879E',
    '--secondary-foreground': '#F2F2F4',
    '--streak': '#BEC3D2',
    '--success': '#22c55e',
    '--success-foreground': '#2A2F3C',
    '--xp': '#BEC3D2',
    '--xp-bg': '#363C4C'
  },
  resolvedVars: {
    '--accent': '#7E879E',
    '--accent-foreground': '#2A2F3C',
    '--accent-foreground-hsl': '223 18% 20%',
    '--accent-foreground-oklch': 'from #2A2F3C l c h',
    '--accent-hsl': '223 14% 56%',
    '--accent-oklch': 'from #7E879E l c h',
    '--background': '#2A2F3C',
    '--background-hsl': '223 18% 20%',
    '--background-oklch': 'from #2A2F3C l c h',
    '--border': '#7E879E',
    '--border-hsl': '223 14% 56%',
    '--border-oklch': 'from #7E879E l c h',
    '--border-w': '1px',
    '--card': '#363C4C',
    '--card-border-active': 'rgba(190, 195, 210, 0.08)',
    '--card-completed': '#3C4354',
    '--card-completed-hsl': '222 17% 28%',
    '--card-completed-oklch': 'from #3C4354 l c h',
    '--card-foreground': '#F2F2F4',
    '--card-foreground-hsl': '240 8% 95%',
    '--card-foreground-oklch': 'from #F2F2F4 l c h',
    '--card-glow': 'rgba(190, 195, 210, 0.08)',
    '--card-hsl': '224 17% 25%',
    '--card-oklch': 'from #363C4C l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2F3C',
    '--destructive-foreground-hsl': '223 18% 20%',
    '--destructive-foreground-oklch': 'from #2A2F3C l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F2F2F4',
    '--foreground-hsl': '240 8% 95%',
    '--foreground-oklch': 'from #F2F2F4 l c h',
    '--hold-fill': '#BEC3D2',
    '--hold-fill-hsl': '225 18% 78%',
    '--hold-fill-oklch': 'from #BEC3D2 l c h',
    '--input': '#363C4C',
    '--input-hsl': '224 17% 25%',
    '--input-oklch': 'from #363C4C l c h',
    '--modal-bg': '#2A2F3C',
    '--modal-bg-hsl': '223 18% 20%',
    '--modal-bg-oklch': 'from #2A2F3C l c h',
    '--modal-border': '#7E879E',
    '--modal-border-hsl': '223 14% 56%',
    '--modal-border-oklch': 'from #7E879E l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#363C4C',
    '--muted-foreground': '#BEC3D2',
    '--muted-foreground-hsl': '225 18% 78%',
    '--muted-foreground-oklch': 'from #BEC3D2 l c h',
    '--muted-hsl': '224 17% 25%',
    '--muted-oklch': 'from #363C4C l c h',
    '--nav-active': '#BEC3D2',
    '--nav-active-hsl': '225 18% 78%',
    '--nav-active-oklch': 'from #BEC3D2 l c h',
    '--nav-bg': '#2A2F3C',
    '--nav-bg-hsl': '223 18% 20%',
    '--nav-bg-oklch': 'from #2A2F3C l c h',
    '--popover': '#363C4C',
    '--popover-foreground': '#F2F2F4',
    '--popover-foreground-hsl': '240 8% 95%',
    '--popover-foreground-oklch': 'from #F2F2F4 l c h',
    '--popover-hsl': '224 17% 25%',
    '--popover-oklch': 'from #363C4C l c h',
    '--primary': '#BEC3D2',
    '--primary-foreground': '#2A2F3C',
    '--primary-foreground-hsl': '223 18% 20%',
    '--primary-foreground-oklch': 'from #2A2F3C l c h',
    '--primary-hsl': '225 18% 78%',
    '--primary-oklch': 'from #BEC3D2 l c h',
    '--radius': '14px',
    '--ring': '#BEC3D2',
    '--ring-hsl': '225 18% 78%',
    '--ring-oklch': 'from #BEC3D2 l c h',
    '--secondary': '#7E879E',
    '--secondary-foreground': '#F2F2F4',
    '--secondary-foreground-hsl': '240 8% 95%',
    '--secondary-foreground-oklch': 'from #F2F2F4 l c h',
    '--secondary-hsl': '223 14% 56%',
    '--secondary-oklch': 'from #7E879E l c h',
    '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 25%, transparent)',
    '--streak': '#BEC3D2',
    '--streak-hsl': '225 18% 78%',
    '--streak-oklch': 'from #BEC3D2 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A2F3C',
    '--success-foreground-hsl': '223 18% 20%',
    '--success-foreground-oklch': 'from #2A2F3C l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(225 18% 78% / 0.15)',
    '--xp': '#BEC3D2',
    '--xp-bg': '#363C4C',
    '--xp-bg-hsl': '224 17% 25%',
    '--xp-bg-oklch': 'from #363C4C l c h',
    '--xp-hsl': '225 18% 78%',
    '--xp-oklch': 'from #BEC3D2 l c h'
  }
}
